import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
	button: {
		lineHeight: 1.5
	},
	icon: {
		fontSize: '20px',
		paddingRight: '5px'
	}
});

const IconButton = ({ icon, children, ...props }) => {
	const classes = useStyles();
	const customIcon = React.cloneElement(icon, { className: classes.icon });

	return (
		<Button {...props} className={classes.button}>
			{customIcon}
			{children}
		</Button>
	);
};

IconButton.defaultProps = {
	size: "small",
	color: "primary"
};

IconButton.propTypes = {
	size: PropTypes.string,
	color: PropTypes.string,
	icon: PropTypes.element.isRequired
};

export default IconButton;
